import { useQuery } from '@tanstack/react-query';
import { clientFetch } from '~/lib/.client/fetch';
import { projectStore } from '~/lib/stores/project';
import { invariant } from '~/utils/invariant';

const getSuggestions = async (projectId?: string) => {
  invariant(projectId);

  const performanceResponse = await clientFetch(`/api/supabase/projects/${projectId}/performance`);

  const parsedPerformanceResponse = await performanceResponse.json<{
    error?: { message: string };
    lints: any[];
  }>();

  if (parsedPerformanceResponse.error) {
    throw new Error(parsedPerformanceResponse.error.message);
  }

  const performanceLints = (parsedPerformanceResponse?.lints || []).map((lint) => ({
    ...lint,
    type: 'performance' as const,
  }));

  const securityResponse = await clientFetch(`/api/supabase/projects/${projectId}/security`);

  const parsedSecurityResponse = await securityResponse.json<{
    error?: { message: string };
    lints: any[];
  }>();

  if (parsedSecurityResponse.error) {
    throw new Error(parsedSecurityResponse.error.message);
  }

  const securityLints = (parsedSecurityResponse?.lints || []).map((lint) => ({
    ...lint,
    type: 'security' as const,
  }));

  return [...performanceLints, ...securityLints];
};

export const useGetSuggestions = () => {
  const projectId = projectStore.projectId.get();

  return useQuery({
    queryKey: ['suggestions', projectId],
    queryFn: () => getSuggestions(projectId),
    enabled: !!projectId,
    retry: false,
  });
};
